import React, { useState } from "react"
import { useStore } from "../../teafuljs/store"
import scrollToElement from "scroll-to-element"
import GetSegment from "../../scripts/NavigateToSegment"
import { Doughnut } from "react-chartjs-2"
import { HorizontalBar } from "react-chartjs-2"
// import Foundational from '../../../static/images/Foundational.png'
import Celebration from "../../../static/images/Celebration.png"
import Communications from "../../../static/images/Communications.png"
import Economics from "../../../static/images/Economics.png"
import Education from "../../../static/images/Education.png"
import Family from "../../../static/images/Family.png"
import Government from "../../../static/images/Government.png"
import Religion from "../../../static/images/Religion.png"
// import scrollToElement from 'scroll-to-element'
import SourceIcons from "../../data/SourceIcons.json"
import Button from "@material-ui/core/Button"
import Divider from "@material-ui/core/Divider"
import { getTranslation } from "../../scripts/getTranslation"

import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles({
  // main: {
  //   display: 'flex',
  //   justifyContent: 'center',
  //   flexWrap: 'wrap',
  //   textAlign: 'center',
  //   marginBottom: '75px',
  //   maxHeight: 'fit-content',
  // },
  occurrences: {
    height: "300px",
    width: "100%",
    // margin: '0 auto',
    position: "relative",
    padding: 0,
    // marginBottom: '-50px'
  },
  byBook: {
    height: "600px",
    width: "100%",
    // margin: '0 auto',
    position: "relative",
  },
  chartholder: {
    position: "relative",
    width: "100%",
    height: "100%",
    padding: "5px",
  },
  blackButton: {
    color: "black",
    backgroundColor: "rgb(201, 201, 201)",
    borderColor: "black",
    margin: "2px",
  },
  redButton: {
    color: "#d60000",
    backgroundColor: "#ffadad",
    borderColor: "#d60000",
    margin: "2px",
  },
  greenButton: {
    color: "#006400",
    backgroundColor: "#b9f8b9",
    borderColor: "#006400",
    margin: "2px",
  },
  blueButton: {
    color: "darkblue",
    backgroundColor: "rgb(142, 227, 255)",
    borderColor: "darkblue",
    margin: "2px",
  },
  red: {
    color: "#d60000",
  },
  green: {
    color: "#006400",
  },
  blue: {
    color: "darkblue",
  },
  selected: {
    fontWeight: "bold",
    textDecoration: "underline",
    border: "2px black solid",
  },
  roles: {
    width: "100%",
    height: "auto",
    display: "flex",
    justifyContent: "center",
    marginTop: "10px",
  },
  roleSelectButton: {
    padding: "2px",
  },
  showReferences: {
    margin: "5px",
    padding: "5px",
    textAlign: "center",
  },
  fourColorCircle: {
    flex: "0 1 25px",
    margin: "0 auto",
    height: "25px",
    width: "25px",
  },
  fourColorImage: {
    borderRadius: "50%",
  },
  blackCircle: {
    flex: "0 1 25px",
    borderRadius: "50%",
    height: "25px",
    width: "25px",
    backgroundColor: "grey",
    margin: "0 auto",
  },
  redCircle: {
    flex: "0 1 25px",
    borderRadius: "50%",
    height: "25px",
    width: "25px",
    backgroundColor: "#ffadad",
    margin: "0 auto",
  },
  greenCircle: {
    flex: "0 1 25px",
    borderRadius: "50%",
    height: "25px",
    width: "25px",
    backgroundColor: "#b9f8b9",
    margin: "0 auto",
  },
  blueCircle: {
    position: "relative",
    flex: "0 1 25px",
    borderRadius: "50%",
    height: "25px",
    width: "25px",
    backgroundColor: "rgb(142, 227, 255)",
    margin: "0 auto",
  },
  legendDiv: {
    flex: "0 0 40px",
    height: "75px",
    // width: '75px',
    display: "flex",
    flexDirection: "column",
    margin: "2px",
    textAlign: "center",
    // border: 'solid red 1px'
  },
  legendText: {
    fontSize: "30%",
    color: "grey",
    lineHeight: "1.2",
    // textTransform: 'uppercase',
    textAlign: "center",
    margin: "5px",
  },
  sphereButtonsHolder: {
    position: "relative",
    width: "100%",
    display: "flex",
    justifyContent: "space-evenly",
    flexWrap: "wrap",
    margin: "10px 0",
  },
  sphereButton: {
    flex: "0 0 45px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    margin: "5px",
    borderRadius: "50%",
  },
  activeSphereButton: {
    border: "2px solid black",
    borderRadius: "50%",
  },
  sphereImage: {
    width: "35px",
    height: "35px",
  },
  recipient: {
    display: "flex",
    justifyContent: "space-between",
    margin: "10px 0 10px 0",
  },
  SVicons: {
    height: "20px",
    width: "20px",
    margin: 0,
  },
  // blackButton: {
  //   color: 'black',
  //   backgroundColor: 'rgb(201, 201, 201)',
  //   borderColor: 'black',
  //   margin: '2px'
  // },
  // redButton: {
  //   color: '#d60000',
  //   backgroundColor: '#ffadad',
  //   borderColor: '#d60000',
  //   margin: '2px'
  // },
  // greenButton: {
  //   color: '#006400',
  //   backgroundColor: '#b9f8b9',
  //   borderColor: '#006400',
  //   margin: '2px'
  // },
  // blueButton: {
  //   color: 'darkblue',
  //   backgroundColor: 'rgb(142, 227, 255)',
  //   borderColor: 'darkblue',
  //   margin: '2px'
  // },
  links: {
    margin: 0,
  },
  recipName: {
    margin: 0,
    textAlign: "right",
    fontSize: "80%",
    // flex: '0 1 200px'
  },
  sourceDivs: {
    maxWidth: "500px",
    margin: "0 auto",
  },
  noRef: {
    fontSize: "80%",
  },
})

const VerbCharts = props => {
  const translations = useStore.translations()[0]
  const AvailableContent = useStore.AvailableContent()[0]
  const language = useStore.language()[0]
  const version = useStore.version()[0]
  const [history, setHistory] = useStore.history()
  const [searchID, setSearchID] = useStore.searchID()
  const [refID, setRefID] = useStore.refID()
  const [currentBook, setCurrentBook] = useStore.currentBook()
  const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID()
  const classes = useStyles()
  const [refColor, updateRefColor] = useState("all")
  const [sphere, updateSphere] = useState(null)
  const [expanded, setExpanded] = React.useState(null)

  function updateExpanded(name) {
    setExpanded(name)
  }

  function changeSphere(clickedSphere) {
    if (clickedSphere === sphere) {
      updateSphere(null)
    } else {
      updateSphere(clickedSphere)
    }
  }

  const verbFile = require(`../../data/Verbs/${props.fileRef}.json`)

  const legendOpts = {
    position: "bottom",
    // display: false,
    labels: {
      fontSize: 9,
      boxWidth: 40,
    },
    onClick: (e, item) => {
      console.log(e, item)
      const label = item.text
      if (label === "Narrator" && refColor !== "black") {
        updateRefColor("black")
      } else if (label === "God" && refColor !== "red") {
        updateRefColor("red")
      } else if (label === "Lead Character(s)" && refColor !== "green") {
        updateRefColor("green")
      } else if (label === "Other Character(s)" && refColor !== "blue") {
        updateRefColor("blue")
      } else {
        updateRefColor("all")
      }
    },
  }

  const legend = useState(legendOpts)[0]

  // ------- OCCURRENCES DOUGHNUT CHART------- //
  const occurrenceData = {
    labels: [
      `OtherVerbs (${verbFile[props.verbRef].NumOthersVerbs})`,
      `SharedVerbs (${verbFile[props.verbRef].NumSharedVerbs})`,
      `GodVerbs (${verbFile[props.verbRef].NumGodVerbs})`,
    ],
    datasets: [
      {
        data: [
          verbFile[props.verbRef].NumOthersVerbs,
          verbFile[props.verbRef].NumSharedVerbs,
          verbFile[props.verbRef].NumGodVerbs,
        ],
        backgroundColor: [
          "rgb(142, 227, 255)",
          "rgb(174, 145, 209)",
          "#ffadad",
        ],
        hoverBackgroundColor: ["darkblue", "rgb(111, 28, 212)", "#d60000"],
      },
    ],
  }
  const occurrenceOptions = {
    title: {
      display: true,
      text: `${(
        verbFile[props.verbRef].NumGodVerbs +
        verbFile[props.verbRef].NumSharedVerbs +
        verbFile[props.verbRef].NumOthersVerbs
      ).toLocaleString()} Total Occurrences`,
      fontSize: 16,
    },
    maintainAspectRatio: false,
    responsive: true,
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 0,
        bottom: 50,
      },
    },
    legend: {
      position: "top",
      labels: {
        fontSize: 9,
        boxWidth: 40,
      },
      display: false,
    },
  }

  // -------BOOK BAR CHART------- //
  const books = Object.keys(verbFile[props.verbRef].bookCounts)
  const VerbByBookData = () => {
    let data = {
      GodVerb: [],
      SharedVerb: [],
      OthersVerb: [],
    }
    books.forEach(book => {
      data.GodVerb.push(verbFile[props.verbRef].bookCounts[book].GodVerbs)
      data.SharedVerb.push(verbFile[props.verbRef].bookCounts[book].SharedVerbs)
      data.OthersVerb.push(verbFile[props.verbRef].bookCounts[book].OthersVerbs)
    })
    return data
  }

  const bookData = {
    labels: books,
    datasets: [
      {
        label: "GodVerbs",
        backgroundColor: "#ffadad",
        hoverBackgroundColor: "#d60000",
        data: VerbByBookData().GodVerb,
      },
      {
        label: "SharedVerbs",
        backgroundColor: "rgb(174, 145, 209)",
        hoverBackgroundColor: "rgb(111, 28, 212)",
        data: VerbByBookData().SharedVerb,
      },
      {
        label: "OtherVerbs",
        backgroundColor: "rgb(142, 227, 255)",
        hoverBackgroundColor: "darkblue",
        data: VerbByBookData().OthersVerb,
      },
    ],
  }

  const bookDataOptions = {
    title: {
      display: true,
      text: "Occurrences by OT Book",
      fontSize: 16,
    },
    legend: {
      position: "top",
      display: false,
    },
    scales: {
      xAxes: [
        {
          stacked: true,
          ticks: {
            stepSize: 1,
          },
        },
      ],
      yAxes: [{ stacked: true }],
    },
    maintainAspectRatio: false,
    responsive: true,
  }

  // ------- OCCURRENCES DOUGHNUT CHART------- //

  // group the references into colors
  const groupedReferencesByColor = () => {
    const all = verbFile[props.verbRef].GodRefs
    const black = verbFile[props.verbRef].GodRefs.filter(
      ref => ref.color === "black"
    )
    const red = verbFile[props.verbRef].GodRefs.filter(
      ref => ref.color === "red"
    )
    const green = verbFile[props.verbRef].GodRefs.filter(
      ref => ref.color === "green"
    )
    const blue = verbFile[props.verbRef].GodRefs.filter(
      ref => ref.color === "blue"
    )
    const error = all.filter(ref => ref.ref === undefined)
    console.log(all.indexOf(error))
    return {
      black,
      red,
      green,
      blue,
      all,
    }
  }
  // count groups
  const countGroupedRefs = () => {
    return {
      black: groupedReferencesByColor().black.length,
      red: groupedReferencesByColor().red.length,
      green: groupedReferencesByColor().green.length,
      blue: groupedReferencesByColor().blue.length,
    }
  }

  const groupedReferences = (color, sphere) => {
    // if there's a specific color AND a specific sphere (BOTH COLOR & SPHERE)
    if (color !== "all" && sphere) {
      console.log(`specific color: ${color} && specific sphere: ${sphere}`)
      const refs = verbFile[props.verbRef].GodRefs.filter(ref => {
        if (
          ref.color === color &&
          (!ref.spheres || ref.spheres.indexOf(sphere) !== -1)
        ) {
          return true
        } else {
          return false
        }
      })
      return refs
    }
    // if there's no specific color AND a specific sphere (SPHERE ONLY)
    else if ((color === "all") & (sphere !== null)) {
      const refs = verbFile[props.verbRef].GodRefs.filter(ref => {
        if (!ref.spheres || ref.spheres.indexOf(sphere) !== -1) {
          return true
        } else {
          return false
        }
      })
      return refs
    }
    // if there's a specific color AND no sphere (COLOR ONLY)
    else if (color !== "all" && !sphere) {
      const refs = verbFile[props.verbRef].GodRefs.filter(ref => {
        if (ref.color === color) {
          return true
        } else {
          return false
        }
      })
      return refs
    }
    // all (NO COLOR, NO SPHERE)
    else {
      return verbFile[props.verbRef].GodRefs
    }
  }

  function sortBySource(refs) {
    let sourcesObj = {}
    refs.forEach(ref => {
      if (sourcesObj[ref.source]) {
        sourcesObj[ref.source].push(ref)
      } else {
        sourcesObj[ref.source] = [ref]
      }
    })
    //sort names alphabetically
    let nameOrderedArrayOfSources = Object.entries(sourcesObj).sort((a, b) => {
      var textA = a[0].toUpperCase()
      var textB = b[0].toUpperCase()
      return textA < textB ? -1 : textA > textB ? 1 : 0
    })

    // sort by reference counts (greatest to least)
    let countOrderedArrayOfSources = nameOrderedArrayOfSources.sort((a, b) => {
      const aOccurrences = a[1].length
      const bOccurrences = b[1].length
      return aOccurrences > bOccurrences
        ? -1
        : aOccurrences < bOccurrences
        ? 1
        : 0
    })
    return countOrderedArrayOfSources
  }

  const SourceRoleData = {
    labels: [`Narrator`, `God`, `Lead Character(s)`, `Other Character(s)`],
    datasets: [
      {
        data: [
          countGroupedRefs().black,
          countGroupedRefs().red,
          countGroupedRefs().green,
          countGroupedRefs().blue,
        ],
        backgroundColor: ["grey", "#ffadad", "#b9f8b9", "rgb(142, 227, 255)"],
        hoverBackgroundColor: ["black", "#d60000", "#006400", "darkblue"],
      },
    ],
  }
  const SourceRoleOptions = {
    title: {
      display: true,
      text: "Source Role Comparison",
      fontSize: 16,
    },
    maintainAspectRatio: false,
    responsive: true,
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 0,
        bottom: 0,
      },
    },
    // legend: {
    //   position: 'bottom',
    //   // display: false,
    //   labels: {
    //     fontSize: 12,
    //     boxWidth: 15
    //   },
    //   // display: false
    // },
  }

  async function navigateToRef(ref) {
    setHistory([
      {
        page: window.location.pathname,
        language: language,
        version: version,
        segment: currentSegmentID,
        scrollY: window.scrollY,
      },
      ...history,
    ])
    const splitRef = ref.split(" ")
    const book = splitRef[0]
    const splitRef2 = splitRef[1].split(":")
    const chapter = splitRef2[0]
    let verse = splitRef2[1]
    if (verse[verse.length - 1].match(/[a-z]/) !== null) {
      verse = verse.slice(0, -1)
    }
    const segment = GetSegment(book, chapter, verse)
    if (currentSegmentID === segment) {
      props.close()
      const elements = Array.from(
        document.querySelectorAll(`[verseref=ref-${book}-${chapter}-${verse}]`)
      )
      const element = elements.find(
        el =>
          !el.getAttribute("data-verse") &&
          !(
            el.getAttribute("style") &&
            el.getAttribute("style").includes("display: none")
          )
      )
      scrollToElement(element, {
        offset: -65,
        ease: "inOutCube",
        duration: 1500,
      })
    } else {
      props.close()
      setCurrentSegmentID(segment)
      setCurrentBook(book)
      setRefID("")
      setSearchID(`${book}-${chapter}-${verse}`)
    }
  }

  return (
    <div className={classes.main}>
      <Divider />
      <div className={classes.occurrences}>
        <div className={classes.chartholder}>
          <Doughnut
            data={occurrenceData}
            options={occurrenceOptions}
            height={10}
            width={10}
          />
        </div>
      </div>
      <Divider />
      <div
        className={classes.byBook}
        style={{ height: `${bookData.labels.length * 12 + 100}px` }}
      >
        <div className={classes.chartholder}>
          <HorizontalBar
            data={bookData}
            width={null}
            height={null}
            options={bookDataOptions}
            getElementAtEvent={el => console.log(el)}
            onElementsClick={elems => {
              // if required to build the URL, you can
              // get datasetIndex and value index from an `elem`:
              // (e, item) => updateRefColors(item.index, refColor)
              console.log(elems)
            }}
          />
        </div>
      </div>
      <Divider />
      <div className={classes.occurrences}>
        <div className={classes.chartholder}>
          <Doughnut
            data={SourceRoleData}
            options={SourceRoleOptions}
            height={10}
            width={10}
            key={"doughnut"}
            legend={legend}
            getElementAtEvent={el => {
              if (el[0]) {
                const label = el[0]._model.label
                if (label === "Narrator" && refColor !== "black") {
                  updateRefColor("black")
                } else if (label === "God" && refColor !== "red") {
                  updateRefColor("red")
                } else if (
                  label === "Lead Character(s)" &&
                  refColor !== "green"
                ) {
                  updateRefColor("green")
                } else if (
                  label === "Other Character(s)" &&
                  refColor !== "blue"
                ) {
                  updateRefColor("blue")
                } else {
                  updateRefColor("all")
                }
              }
            }}
            //   onElementsClick={elems => {
            //     // if required to build the URL, you can
            //     // get datasetIndex and value index from an `elem`:
            //     // (e, item) => updateRefColors(item.index, refColor)
            //     console.log(elems)
            // }}
          />
        </div>
      </div>
      {/* <div className={classes.roles}>
        <div className={classes.legendDiv}>
          <div className={classes.fourColorCircle} onClick={() => updateRefColor({color: 'all', index: 4})} title="All">
            <img className={`${classes.fourColorImage} ${(refColor.color === 'all') ? classes.selected : null}`} src={FourColorCircle} alt="All Sources"/>
          </div>
          <p className={classes.legendText}>All</p>
        </div>
        <div className={classes.legendDiv}>
          <div className={`${classes.blackCircle} ${(refColor.color === 'black') ? classes.selected : null}`} onClick={() => updateRefColor({color: 'black', index: 0})} title="Narrator"></div>
          <p className={classes.legendText}>Narrator</p>
        </div>
        <div className={classes.legendDiv}>
          <div className={`${classes.redCircle} ${(refColor.color === 'red') ? classes.selected : null}`} onClick={() => updateRefColor({color: 'red', index: 1})} title="God"></div>
          <p className={classes.legendText}>God</p>
        </div>
        <div className={classes.legendDiv}>
          <div className={`${classes.greenCircle} ${(refColor.color === 'green') ? classes.selected : null}`} onClick={() => updateRefColor({color: 'green', index: 2})} title="Lead Character(s)"></div>
          <p className={classes.legendText}>Lead Character(s)</p>
        </div>
        <div className={classes.legendDiv}>
          <div className={`${classes.blueCircle} ${(refColor.color === 'blue') ? classes.selected : null}`} onClick={() => updateRefColor({color: 'blue', index: 4})} title="Other Character(s)"></div>
          <p className={classes.legendText}>Other Character(s)</p>
        </div>
      </div> */}
      {/* <Divider />
      <div className={classes.showReferences}>
        <Button color='primary' variant={(showRefs) ? "outlined" : "contained"} onClick={() => updateShowRefs(!showRefs)}>{(showRefs) ? "Hide References" : "Show References"}</Button>
        {(showRefs) ? (
          <div className={classes.roles}>
            <span className={`${classes.black} ${classes.roleSelectButton} ${(refColor === 'all') && classes.selected}`} onClick={() => updateRefColor('all')}>All</span>
            <span className={`${classes.black} ${classes.roleSelectButton} ${(refColor === 'black') && classes.selected}`} onClick={() => updateRefColor('black')}>Black</span>
            <span className={`${classes.red} ${classes.roleSelectButton} ${(refColor === 'red') && classes.selected}`} onClick={() => updateRefColor('red')}>Red</span>
            <span className={`${classes.green} ${classes.roleSelectButton} ${(refColor === 'green') && classes.selected}`} onClick={() => updateRefColor('green')}>Green</span>
            <span className={`${classes.blue} ${classes.roleSelectButton} ${(refColor === 'blue') && classes.selected}`} onClick={() => updateRefColor('blue')}>Blue</span>

          </div>
        ) : null}
      </div> */}
      <Divider className={classes.sourceDivs} />
      {props.verbRef === "H593" ||
      props.verbRef === "H615" ||
      props.verbRef === "H650" ? (
        <div className={`${classes.sphereButtonsHolder} ${classes.sourceDivs}`}>
          <div
            className={classes.sphereButton}
            onClick={() => changeSphere("Family")}
          >
            <img
              src={Family}
              className={`${classes.sphereImage} ${
                sphere === "Family" ? classes.activeSphereButton : null
              }`}
              alt=""
            />
          </div>
          <div
            className={classes.sphereButton}
            onClick={() => changeSphere("Economics")}
          >
            <img
              src={Economics}
              className={`${classes.sphereImage} ${
                sphere === "Economics" ? classes.activeSphereButton : null
              }`}
              alt=""
            />
          </div>
          <div
            className={classes.sphereButton}
            onClick={() => changeSphere("Government")}
          >
            <img
              src={Government}
              className={`${classes.sphereImage} ${
                sphere === "Government" ? classes.activeSphereButton : null
              }`}
              alt=""
            />
          </div>
          <div
            className={classes.sphereButton}
            onClick={() => changeSphere("Religion")}
          >
            <img
              src={Religion}
              className={`${classes.sphereImage} ${
                sphere === "Religion" ? classes.activeSphereButton : null
              }`}
              alt=""
            />
          </div>
          <div
            className={classes.sphereButton}
            onClick={() => changeSphere("Education")}
          >
            <img
              src={Education}
              className={`${classes.sphereImage} ${
                sphere === "Education" ? classes.activeSphereButton : null
              }`}
              alt=""
            />
          </div>
          <div
            className={classes.sphereButton}
            onClick={() => changeSphere("Communications")}
          >
            <img
              src={Communications}
              className={`${classes.sphereImage} ${
                sphere === "Communications" ? classes.activeSphereButton : null
              }`}
              alt=""
            />
          </div>
          <div
            className={classes.sphereButton}
            onClick={() => changeSphere("Celebration")}
          >
            <img
              src={Celebration}
              className={`${classes.sphereImage} ${
                sphere === "Celebration" ? classes.activeSphereButton : null
              }`}
              alt=""
            />
          </div>
        </div>
      ) : null}
      {refColor !== "all" ? (
        // if there is sphere data available
        sortBySource(groupedReferences(refColor, sphere)).length > 0 ? (
          sortBySource(groupedReferences(refColor, sphere)).map(
            (pair, index) => {
              return (
                <React.Fragment key={index}>
                  <div
                    className={classes.sourceDivs}
                    onClick={() =>
                      updateExpanded(expanded === pair[0] ? null : pair[0])
                    }
                  >
                    <div className={classes.recipient}>
                      <img
                        src={require(`../../../static/images/${
                          SourceIcons[pair[0]].sourceIcon
                        }.png`)}
                        className={classes.SVicons}
                        alt="Source Name"
                      />
                      <p className={classes.recipName}>
                        {getTranslation(
                          translations,
                          language,
                          "Sources",
                          pair[0]
                        )}{" "}
                        ({pair[1].length})
                      </p>
                    </div>
                  </div>
                  {expanded === pair[0] ? (
                    <div className={`${classes.links} ${classes.sourceDivs}`}>
                      {pair[1].map((refLink, index) => (
                        <Button
                          size="small"
                          className={classes[`${refLink.color}Button`]}
                          // onClick={() => navigateToRef(refLink.ref)}
                          key={index}
                        >
                          {refLink.ref}
                        </Button>
                      ))}
                    </div>
                  ) : null}
                  <Divider className={classes.sourceDivs} />
                </React.Fragment>
              )
            }
          )
        ) : (
          // if there are no spheres data available
          <p className={classes.noRef}>
            Sorry, there are no{" "}
            <em>
              <strong>{refColor}</strong>
            </em>{" "}
            occurrences refering to{" "}
            <em>
              <strong>{sphere}</strong>
            </em>
          </p>
        )
      ) : null}
      <div className={classes.sourceDivs}>
        {(props.verbRef === "H593" ||
          props.verbRef === "H615" ||
          props.verbRef === "H650") &&
        refColor === "all"
          ? groupedReferences(refColor, sphere).map(refButton => (
              <Button
                size="small"
                className={classes[`${refButton.color}Button`]}
                key={refButton.ref}
                onClick={
                  refButton.ref.substring(0, 3) === "Jon" ||
                  refButton.ref.substring(0, 3) === "Rut"
                    ? () => navigateToRef(refButton.ref)
                    : null
                }
              >
                {refButton.ref}
              </Button>
            ))
          : refColor === "all"
          ? groupedReferencesByColor()[refColor].map(refButton => (
              <Button
                size="small"
                className={classes[`${refButton.color}Button`]}
                key={refButton.ref}
                onClick={
                  refButton.ref.substring(0, 3) === "Jon" ||
                  refButton.ref.substring(0, 3) === "Rut"
                    ? () => navigateToRef(refButton.ref)
                    : null
                }
              >
                {refButton.ref}
              </Button>
            ))
          : null}
      </div>
    </div>
  )
}

export default VerbCharts
